import React from "react";
import {
  ApiGeneralDataResponse,
  BotData,
  BotMetadata,
  QueryStatus,
} from "@shared/types";

export const BotDetailsContext = React.createContext<
  | {
      getBotDataStatus: QueryStatus<ApiGeneralDataResponse<BotData>>;
      botData: BotData | undefined;
      getBotMetadataStatus: QueryStatus<BotMetadata>;
      botMetadata: BotMetadata | undefined;
      isChannelConfiguration?: boolean;
      botId?: number;
      refetch?: () => void;
      isLoading?: boolean;
    }
  | undefined
>(undefined);
